import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
interface ProductDetailsProps {
  productId: string | undefined;
  isOpen: boolean;
}
interface ProductDetails {
  name: string;
  description: string;
  product_screen?: string;
}
export function ProductDetails({
  productId,
  isOpen
}: ProductDetailsProps) {
  const [productDetails, setProductDetails] = useState<ProductDetails | null>(null);

  // Fetch product details
  useEffect(() => {
    const fetchProductDetails = async () => {
      if (!productId) return;
      try {
        const {
          data,
          error
        } = await supabase.from('products').select('name, description, product_screen').eq('id', productId).single();
        if (error) throw error;
        if (data) {
          setProductDetails({
            name: data.name,
            description: data.description || "",
            product_screen: data.product_screen
          });
        }
      } catch (error) {
        console.error('Error fetching product details:', error);
      }
    };
    if (isOpen && productId) {
      fetchProductDetails();
    }
  }, [isOpen, productId]);
  if (!productDetails) return null;
  return <div className="md:w-1/2 p-6 bg-white overflow-y-auto">
      {productDetails.product_screen && <div className="mt-2 mb-6">
          <img src={productDetails.product_screen} alt={`${productDetails.name} screenshot`} className="w-full rounded-lg object-cover" />
        </div>}
      
      {productDetails.description && <div className="mb-6">
          
          <div className="text-gray-700 prose prose-sm max-w-none" dangerouslySetInnerHTML={{
        __html: productDetails.description
      }} />
        </div>}
    </div>;
}